import { Axiom } from "@axiomhq/js";
import {
  AxiomJSTransport,
  ConsoleTransport,
  Logger,
  type Transport,
} from "@axiomhq/logging";
import { createUseLogger, createWebVitalsComponent } from "@axiomhq/react";
import { AXIOM_DATASET, AXIOM_TOKEN } from "../config";

export const isAxiomEnabled = Boolean(AXIOM_TOKEN && AXIOM_DATASET);

const transports: Transport[] = [];

if (isAxiomEnabled) {
  transports.push(
    new AxiomJSTransport({
      axiom: new Axiom({ token: AXIOM_TOKEN }),
      dataset: AXIOM_DATASET,
      axiomClient: "shonei-blogs/ui",
    }),
  );
}

// Dev: also mirror to the browser console. Production without Axiom: silent no-op transport.
if (process.env.NODE_ENV !== "production") {
  transports.push(new ConsoleTransport({ prettyPrint: true }));
}

if (transports.length === 0) {
  transports.push(new ConsoleTransport());
}

export const logger = new Logger({
  transports: transports as [Transport, ...Transport[]],
  logLevel: isAxiomEnabled || process.env.NODE_ENV !== "production" ? "info" : "off",
  args: {
    app: "shonei-blogs",
    source: "frontend",
  },
});

export const useLogger = createUseLogger(logger);
export const WebVitals = createWebVitalsComponent(logger);

/** Capture uncaught errors / rejections and flush on page hide. */
export function initAxiomErrorReporting() {
  if (typeof window === "undefined") return;

  window.addEventListener("error", (event) => {
    logger.error("Unhandled error", {
      message: event.message,
      filename: event.filename,
      lineno: event.lineno,
      colno: event.colno,
      stack: event.error instanceof Error ? event.error.stack : undefined,
    });
    void logger.flush();
  });

  window.addEventListener("unhandledrejection", (event) => {
    const reason = event.reason;
    logger.error("Unhandled promise rejection", {
      reason: reason instanceof Error ? reason.message : String(reason),
      stack: reason instanceof Error ? reason.stack : undefined,
    });
    void logger.flush();
  });

  window.addEventListener("pagehide", () => {
    void logger.flush();
  });
}
